<div *ngIf="!isLoading else loadingView">
    <div class="p-flex-row p-d-flex mb-2">

        <div class="p-flex-column p-d-flex ml-2 mt-1">
            <b>From Year</b>
        </div>
        <div class="p-flex-column p-d-flex ml-2 mb-2">
            <p-dropdown
                    [(ngModel)]="yearBefore"
                    [options]="fromYear"
                    [filter]="true"
                    optionLabel="name"
                    placeholder="Select Year"
            ></p-dropdown>
        </div>
        <div class="p-flex-column p-d-flex ml-2 mt-1">
            <b>To Year</b>
        </div>
        <div class="p-flex-column p-d-flex ml-2 mb-2">
            <p-dropdown
                    [(ngModel)]="yearAfter"
                    [options]="toYear"
                    [filter]="true"
                    optionLabel="name"
                    placeholder="Select Year"
            ></p-dropdown>
        </div>
        <div class="p-flex-column p-d-flex ml-2 mb-2">
            <button class="cas-button-action" (click)="refreshList()">REFRESH</button>
        </div>
    </div>
    <p-table [value]="dataSources" *ngIf="dataSources.length > 0 else noContingencyFund"
             styleClass="p-datatable-gridlines">
        <ng-template pTemplate="header">
            <tr>
                <th class="cas-data-cell">
                </th>
                <th class="cas-data-cell">
                </th>
                <th class="cas-data-cell" colspan="2" style="text-align: center">
                    <span style="color: gray">EXPENDITURE</span>
                </th>
                <th class="cas-data-cell" colspan="2" style="text-align: center">
                    <span style="color: gray">INCOME</span>
                </th>
                <th class="cas-data-cell" colspan="2">
                </th>
            </tr>
            <tr>
                <th class="cas-data-cell">
                    <span>Year</span>
                </th>
                <th class="cas-data-cell">
                    <span>Balance</span>
                </th>
                <th class="cas-data-cell">
                    <span>Budget</span>
                </th>
                <th class="cas-data-cell">
                    <span>Actual</span>
                </th>
                <th class="cas-data-cell">
                    <span>Budget</span>
                </th>
                <th class="cas-data-cell">
                    <span>Actual</span>
                </th>
                <th class="cas-data-cell" colspan="2">
                    <span> </span>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-record>
            <tr>
                <td class="cas-data-cell">
                    <span class="p-column-title">Year</span>
                    <div class="cas-data-cell-data">{{record.year}}</div>
                </td>
                <td class="cas-data-cell" *ngIf="!record.edit || (accountName === 'Contingency Fund')">
                    <span class="p-column-title">Balance</span>
                    <div class="cas-data-cell-data">{{record.balance}}</div>
                </td>
                <td class="cas-data-cell" *ngIf="record.edit && (accountName !== 'Contingency Fund')">
                    <input type="number" class="cas-edit-input" [(ngModel)]="record.balance">
                </td>
                <td class="cas-data-cell" *ngIf="!record.edit || (accountName === 'Contingency Fund')">
                    <span class="p-column-title">Budget</span>
                    <div class="cas-data-cell-data">{{record.expense_budget}}</div>
                </td>
                <td class="cas-data-cell" *ngIf="record.edit && (accountName !== 'Contingency Fund')">
                    <input type="number" class="cas-edit-input" [(ngModel)]="record.expense_budget">
                </td>
                <td class="cas-data-cell" *ngIf="!record.edit || (accountName === 'Contingency Fund')">
                    <span class="p-column-title">Actual</span>
                    <div class="cas-data-cell-data">{{record.expense_actual}}</div>
                </td>
                <td class="cas-data-cell" *ngIf="record.edit && (accountName !== 'Contingency Fund')">
                    <input type="number" class="cas-edit-input" [(ngModel)]="record.expense_actual">
                </td>

                <td class="cas-data-cell" *ngIf="!record.edit">
                    <span class="p-column-title">Budget</span>
                    <div class="cas-data-cell-data">{{record.income_budget}}</div>
                </td>
                <td class="cas-data-cell" *ngIf="record.edit">
                    <input type="number" class="cas-edit-input" [(ngModel)]="record.income_budget">
                </td>
                <td class="cas-data-cell" *ngIf="!record.edit || (accountName === 'Contingency Fund')">
                    <span class="p-column-title">Actual</span>
                    <div class="cas-data-cell-data">{{record.income_actual}}</div>
                </td>
                <td class="cas-data-cell" *ngIf="record.edit && (accountName !== 'Contingency Fund')">
                    <input type="number" class="cas-edit-input" [(ngModel)]="record.income_actual">
                </td>
                <td *ngIf="!record.edit" colspan="2">
                    <button *ngIf="!record.edit" class="p-d-flex p-flex-column" (click)="toggleEdit(record)">Edit
                    </button>
                </td>
                <td colspan="2" *ngIf="record.edit">
                    <div class="p-d-flex p-flex-row">
                        <button class="cas-button-action p-d-flex p-flex-column" *ngIf="record.edit"
                                (click)="saveState(record)">Update
                        </button>
                        <button *ngIf="record.edit" class="p-d-flex p-flex-column" (click)="closeEdit(record)">Cancel
                        </button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>

<ng-template #noContingencyFund>
    <p class="cas-error-string">No contingency fund available</p>
</ng-template>
<p-toast position="center"></p-toast>
